import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import LaptopMacOutlinedIcon from "@mui/icons-material/LaptopMacOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { CabinetworksGroupApplication } from "types/declarations/enums.ts";
import { DashboardDestinations } from "../Dashboard.types";
import { useDashboardNavigation } from "../hooks/useDashboardNavigation";
import { DashboardCard } from "./DashboardCard";

const productResourcesIllustrationUrl = new URL("../assets/product-resources-card.svg", import.meta.url).href;

interface ProductResourcesCardProps {
	destinations: Pick<DashboardDestinations, "software" | "filesAndLiterature">;
}

export const ProductResourcesCard = ({ destinations }: ProductResourcesCardProps) => {
	const goTo = useDashboardNavigation();
	return (
		<DashboardCard
			testId="dashboard-product-resources-card"
			title="Product Resources"
			illustration={
				<img
					src={productResourcesIllustrationUrl}
					alt=""
					aria-hidden="true"
				/>
			}
			accent="#0f85b5"
			titleColor="#006594"
			actions={[
				{
					id: "software",
					label: "Software",
					icon: <LaptopMacOutlinedIcon aria-hidden="true" />,
					onClick: () => goTo(destinations.software)
				},
				{
					id: "marketing-materials",
					label: "Marketing Materials",
					icon: <ShoppingCartOutlinedIcon aria-hidden="true" />,
					onClick: () =>
						goTo({ href: "/marketing-materials", application: CabinetworksGroupApplication.Tandem })
				},
				{
					id: "files-literature",
					label: "Files & Literature",
					icon: <AutoStoriesOutlinedIcon aria-hidden="true" />,
					onClick: () => goTo(destinations.filesAndLiterature)
				},
				{
					id: "learning",
					label: "Learning",
					icon: <SchoolOutlinedIcon aria-hidden="true" />,
					onClick: () => goTo({ href: "/sf/learning", application: CabinetworksGroupApplication.Salesforce })
				}
			]}
		/>
	);
};
